<template>
	<section class="experiences defaultSectionMargins">
    <div class="container">
      <h2>{{ data.title }}</h2>
      <p class="experiences__IntroText experiences__IntroText--Left" v-if="data.description">{{ data.description }}</p>
      
      <FlickitySlider class="experiences__Slider experiencesEventsSlider" :options="flickityOptions" @ready="sliderReady" :with-progress="true" :min-number-of-slides="3">
        <div v-for="item in experiences" class="experiences__Item experiencesEventsItem">
          <a :href="item.url" rel="nofollow" target="_blank">{{ $t('seeDetails') }}</a>
  
          <div class="experiencesEvents__ItemImage">
            <img :src="item.image" width="420" height="315" />
            <Button medium secondary>{{ $t('seeDetails') }}</Button>
          </div>
  
          <div class="experiences__ItemContent">
            <h3>{{ item.name }}</h3>
            <div class="experiences__ItemInfos">
              <div>
                <Icon name="clock-small" /> {{ item.duration }}h
              </div>
              <div>
                <Icon name="location" /> {{ item.location.city }}
              </div>
              <div>
                {{ $t('from') }} {{ formatPrice(item.minPrice.amount, item.minPrice.currency, lang, true) }}
              </div>
            </div>
            <p v-if="item.highlight" v-text="item.highlight" />
          </div>
        </div>
      </FlickitySlider>
      <div class="turneo__ExperiencesButton" v-if="data.url">
        <Button type="nuxt-link" :to="data.url" :external="data.link ? true : false" secondary full-width medium>{{ $t('experiences.all') }}</Button>
      </div>
    </div>
  </section>
</template>

<script setup>
	const props = defineProps({
    data: {
      type: Object,
      default: {},
    },
	});

	const { link } = useSetup();
	const { lang } = useLanguage();
  const experiences = ref(null);

  const flickityOptions = {
    pageDots: false,
    contain: true,
    cellAlign: 'left',
  };

  try {
    let response = await useServerFetch(`experience/experiences/?turneo_store=${props.data?.turneo_store}`);
    experiences.value = response.experiences;
  }
  catch(e) {
    console.log(e);
  }

  function sliderReady(slider) {
    setTimeout(() => {
      slider.resize();
    }, 500);
  }
</script>